<div class="user-info-page">
  <div class="container">
    <div class="project-title">
      <h1 class="title">{{userInfo?.user_name}}</h1>
    </div>

    <div class="user-content">
      <cc-output-text [title]="'Sign in ID'" [content]="userInfo?.login_id"></cc-output-text>
    </div>
  </div>

  <div class="container delete-project">
    <div class="button-box">
      <sdc-design-button
      type="warn"
      outline="true"
      title="Sign out"
      width="140px"
      height="40px"
      (click)="handleLogout()"
    ></sdc-design-button>
    </div>
  </div>
</div>
